module.exports = __webpack_public_path__ + "static/tesla-solar-roof-2-540w-46d551930676a18051ee94d6f87b8d95.jpg";